import { apiProxyRequest as request } from "Api/apiProxyRequest";

export const removeContinuousProfiling = (
  organizationId: string,
  subscriptionId: string
) =>
  request<object>(
    `/organizations/${organizationId}/subscriptions/${subscriptionId}`,
    "PATCH",
    { continuous_profiling: "" }
  );
